import { type SxProps, type Theme } from '@mui/system';
import { createTheme } from '@mui/material/styles';

const theme = createTheme();

export const content: SxProps<Theme> = {
  backgroundColor: 'white',
  marginTop: '70px',
  position: 'relative',
  padding: '60px 35px 35px',
  boxShadow: '0px 3px 6px #00000029',
  '& .MuiTabs-root': {
    position: 'absolute',
    top: '-30px',
    height: '60px',
    boxShadow: '0px 3px 6px #00000029',
    '& .MuiTabs-scroller': {
      background: 'white',
    },
    '& .MuiTab-textColorPrimary': {
      color: '#009869',
      fontSize: '18px',
      fontWeight: 'bold',
    },
    '& .MuiTabs-indicator': {
      display: 'flex',
      justifyContent: 'center',
      backgroundColor: 'transparent',
      fontSize: '5px',
      lineHeight: '5px',
      height: '5px',
    },
    '& .MuiTabs-indicatorSpan': {
      maxWidth: '40px',
      height: '5px',
      fontSize: '5px',
      width: '100%',
      backgroundColor: '#009869',
    },
  },
  '& .tab-panel': {
    '& .title': {
      color: '#009869',
      fontSize: '26px',
      fontWeight: 'bold',
      marginBottom: '30px',
    },
  },
};

export const bannerHeader: SxProps<Theme> = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  backgroundColor: '#fff',
  padding: '0px 28px 0px 28px',
  minHeight: '80px',
  boxShadow: '0px 3px 6px #00000029',
  '& .welcomeText': {
    color: '#009869',
    fontWeight: 'bold',
    fontSize: '18px',
    letterSpacing: '0px',
  },
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
  },
};

export const bannerHeaderBox: SxProps<Theme> = {
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'baseline',
  '& button': {
    backgroundColor: '#009869',
    width: '100px',
    height: '25px',
    borderRadius: '2px',
    fontSize: '17px',
    marginRight: '33px',
    boxShadow: 'none',
  },
  '& button:hover': {
    backgroundColor: '#009869',
    boxShadow: 'none',
  },
  '& p': {
    fontSize: '18px',
    color: '#009869',
    margin: '0px',
  },
  '& .userRole': {
    backgroundColor: '#009869',
    width: 'auto',
    padding: '0 5px',
    height: '25px',
    borderRadius: '2px',
    fontSize: '18px',
    marginRight: '33px',
    color: 'white',
    textAlign: 'center',
  },
  [theme.breakpoints.down('sm')]: {
    paddingBottom: '20px',
  },
};

export const bannerMain: SxProps<Theme> = {
  height: '304px',
  '& img': {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
};

export const contentHeading: SxProps<Theme> = {
  color: '#006EC2',
  fontSize: '28px',
  fontWeight: 'bold',
  paddingTop: '45px',
  paddingBottom: '25px',
};

export const cardStyles: SxProps<Theme> = {
  // cursor: 'pointer',
  maxWidth: '380px',
  backgroundColor: 'transparent',
  boxShadow: 'none',
  border: 'none',
  '& .cardTitle': {
    margin: '0px 0px 14px 0px',
    fontSize: '17px',
    color: '#006EC2',
    fontWeight: 'bold',
    letterSpacing: 0,
  },
  '& ul': {
    padding: 0,
  },
  '& ul > li': {
    listStyle: 'none',
    color: '#707070',
    margin: '4px 0px 4px 0px',
    fontSize: '17px',
    display: 'flex',
  },
  '& ul > li > span': {
    marginLeft: '5px',
  },
  '& .cardContent': {
    color: '#707070',
    margin: '4px 0px 4px 0px',
    fontSize: '17px',
  },
  '& .timeText': {
    color: '#707070',
    fontSize: '17px',
    fontWeight: 'bold',
    letterSpacing: 0,
  },
};
